import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Icon, ICONS } from 'components/Icons';

import Problem from './Problem.png';
import Solution from './Solution.png';
import DigDeeper from './DigDeeper.png';
import './AnalyticsSection.scss';

function AnalyticsSection() {
  return (
    <div className="analytics-section">
      <div className="container">
        {/* <Row className="my-5 row-section"> */}
        {/* <Col xs={8} className="pr-md-5"> */}
        <Row className="my-5 row-section">
          <div className="header my-4">
            <Icon icon={ICONS.CHARGE} className="icon" />
            The Problem
          </div>
          <div className="section-sentence">
            Today, we learn about important issues through a random walk
            of emails, texts, push notifications, Facebook feeds, and
            Tweets.
          </div>
          <ul className="problem-list">
            {/* <li>
              <span>
                Today, we learn about important issues through a random walk
                of emails, texts, push notifications, Facebook feeds, and
                Tweets.
              </span>
            </li> */}
            <li>
              <span>
                They feed us <b>outrage</b>, but not <b>understanding</b>.
              </span>
            </li>
            <li>
              <span>
                It's left many of us tired with <b>news fatigue</b>.
              </span>
            </li>
          </ul>
          {/* </Col> */}
        </Row>
        <Row className="my-5 row-section">
          {/* <Col xs={4} className="image-container"> */}
          <div className="image-container">
            <img src={Problem} />
          </div>
          {/* </Col> */}
        </Row>
        {/* </Row> */}
        <Row className="my-5 row-section">
          <div className="header my-4">
            <Icon icon={ICONS.BULB} className="icon" />
            Our Solution
          </div>
          {/* <div>
            Your AverPoint Analytics help you{' '}
            <b>better understand the news</b> you're consuming on your phone,
            computer, and smart TV.
          </div> */}
          <div className="section-sentence">
            Your AverPoint Analytics help you{' '}
            <b>better understand the news</b> you're consuming on your phone,
            computer, and smart TV.
          </div>
          <ul className="solution-list">
            <li>
              <span>You see trends by topic, source, locations, and more</span>
            </li>
            <li>
              <span>
                You can <b>set goals</b>, and read with more intention.
              </span>
            </li>
            <li>
              <span>
                We use these analytics to <b>suggest articles</b> to your
                AverPoint channel.
              </span>
            </li>
          </ul>
        </Row>
        <Row className="my-5 row-section">
          <div className="image-container">
            <img src={Solution} />
          </div>
        </Row>
        <div className="middle-section">
          <div className="header my-3">
            <Icon icon={ICONS.SPEEDOMETER} className="icon" />
            Measure your reading
          </div>
          <div className="section-sentence">
            There are several ways you can log your reading:
          </div>
        </div>
        <Row className="features">
          <Col sm={3} className="feature">
            <Icon icon={ICONS.ANALYTICS_CHANNEL} className="icon" />
            <div className="feature-text">AverPoint Channel</div>
            <div className="feature-sub-text">
              Your Channel suggests articles to maximize your learning about important issues.
            </div>
          </Col>
          <Col sm={3} className="feature">
            <Icon icon={ICONS.ANALYTICS_BROWSER} className="icon" />
            <div className="feature-text">Your browser</div>
            <div className="feature-sub-text">
              Our Chrome Extension logs articles you read from over 1,800 American and 70 international news sites.
            </div>
          </Col>
          <Col sm={3} className="feature">
            <Icon icon={ICONS.ANALYTICS_PHONE} className="icon" />
            <div className="feature-text">Your mobile phone</div>
            <div className="feature-sub-text">
              You can share articles to our mobile app just like you share to a social media app.
            </div>
          </Col>
          <Col sm={3} className="feature">
            <Icon icon={ICONS.ANALYTICS_EMAIL} className="icon" />
            <div className="feature-text">Email articles</div>
            <div className="feature-sub-text">
              Email the article link to our magical inbox and voilà! Your
              article is logged.
            </div>
          </Col>
        </Row>
        <Row className="my-5 row-section">
          <div className="header my-4">
            <Icon icon={ICONS.ZOOM_IN} className="icon" />
            Critical 21st century skills
          </div>
          <div className="section-sentence">
            When you reach Level 2, we help you read{' '}
            <b>more critically</b>
          </div>
          <ul className="dig-deeper-list">
            <li>
              <span><b>Question</b> what you’re reading.</span>
            </li>
            <li>
              <span>
                See the author’s <b>underlying evidence</b>.
              </span>
            </li>
            <li>
              <span>
                Request <b>expert reviews</b>.
              </span>
            </li>
          </ul>
          <div className="image-container">
            <img src={DigDeeper} />
          </div>
        </Row>
      </div>
    </div>
  );
}

export default AnalyticsSection;
